import { render, staticRenderFns } from "./ChallengeBox.vue?vue&type=template&id=56baf8da&scoped=true&"
import script from "./ChallengeBox.vue?vue&type=script&lang=js&"
export * from "./ChallengeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56baf8da",
  null
  
)

export default component.exports